export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const pageInactiveCONST = 'pageInactiveStartTime';
  const refreshScriptFlagCONST = 'refreshScriptFlag';
  const pageInactiveRefreshCONST = runtimeConfig.public?.inactiveRefresh?.ttl || 59; // 1 minute
  const isPageInactiveRefresh = runtimeConfig.public?.inactiveRefresh?.enabled || false; // 1 minute

  const getParameterByName = (name: string): string | null => {
    const url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return 'exist'; }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  const isNeedToReload = (): boolean => {
    const startTime = localStorage.getItem(pageInactiveCONST) || new Date().toString();
    const pageInactiveStartTime = new Date(startTime);
    const seconds = (new Date().getTime() - pageInactiveStartTime.getTime()) / 1000;
    // Log the inactive time for debugging
    return Math.floor(seconds) > pageInactiveRefreshCONST;
  };

  const setRefreshScriptFlag = (): void => {
    localStorage.setItem(refreshScriptFlagCONST, 'true');
  };

  const reloadPage = (): void => {
    window.location.reload();
  };

  const refreshPage = (): void => {
    if (isNeedToReload()) {
      setRefreshScriptFlag();
      reloadPage();
    }
  };

  const setPageInactiveTime = (): void => {
    localStorage.setItem(pageInactiveCONST, new Date().toString());
  };

  const initializePageRefresh = (): void => {
    if (typeof localStorage !== 'undefined') {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          refreshPage();
        } else {
          setPageInactiveTime();
        }
      });
    }
  };
  const isInactiveRefreshRoute = (): boolean => {
    const route = useRoute();
    const routeName = getRouteName(route.name);
    const refreshRoutes = runtimeConfig.public?.inactiveRefresh?.routes || [];
    return refreshRoutes.includes(routeName as string);
  };
  const ignoreRefresh = getParameterByName('ignoreRefresh');
  if (isPageInactiveRefresh && isInactiveRefreshRoute() &&
    (!ignoreRefresh ||
      (ignoreRefresh !== 'exist' && ignoreRefresh.toLowerCase() !== 'true'))
  ) {
    initializePageRefresh();
  }
});
